export default __webpack_public_path__ + "images/26cecd02cc6d40f7fd30135913c9af41.png";